import support from "./support.js";

export default {
  getWebProductModel() {
    return support.get("Product/getWebProductModel")
  },

  saveWebProductModel(data) {
    return support.post("Product/saveWebProductModel", data)
  }
}
